import { ChangeEvent, useCallback, useContext, useEffect } from "react"
import { ConceptStatus, ConceptStatusValidity } from "@fusion-advantage/backcompat"
import { ConceptActivation } from "@fusion-advantage/formlib"
import L6FormContext from "../l6/L6FormContext"
import L1TextArea from "../l1/L1TextArea"
import { FusionColor } from "../../../theme/FusionStyle"
import { validityIndicatorProps } from "../../uiv2/Indicator/StatusIndicatorProps"

interface L3TextAreaProps {
	xpath: string
	conceptStatus: ConceptStatus|null
	validity: ConceptStatusValidity|null
	activation: ConceptActivation|null
	onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
}

const L3TextArea = ({xpath, conceptStatus, validity, activation, onChange}: L3TextAreaProps) => {
	let value = ''
	if(conceptStatus && conceptStatus.value !== null) {
		value = String(conceptStatus.value)
	}
	const isValued = useCallback(() => {
		return value !== ''
	}, [value])
	const { setXpathValuedDeterminer } = useContext(L6FormContext)
	useEffect(() => {
		setXpathValuedDeterminer(xpath, isValued)
		return () => {
			setXpathValuedDeterminer(xpath, false)
		}
	}, [xpath, setXpathValuedDeterminer, isValued])
	let borderColor: FusionColor|undefined
	if(validity) {
		const props = validityIndicatorProps(validity)
		borderColor = props.color
	}
	return (
		<L1TextArea
			value={value}
			disabled={activation === ConceptActivation.Disabled}
			onChange={onChange}
			borderColor={borderColor}
		/>
	)
}

export default L3TextArea
